<template>
  <v-container class="privacy-and-security">
    <v-layout row>
      <v-flex class="my-5">
        <H1>
          Privacy And Security
        </H1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.privacy-and-security {
  display: inherit;
}
</style>

<script>
export default {
  name: 'privacyAndSecurity',
  data () {
    return {
    }
  }
}
</script>
